import { useEffect, useState, useRef } from "react";
import withLoader from "../../../components/layouts/WithLoader";
import SocieteService from "../../../services/Societe";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Link } from "react-router-dom";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import KPIAchatService from "../../../services/KPIAchatService";
import ClientTable from "../../../ui/DataTableClient";
const AllClient = ({ startLoading, stopLoading }) => {
  const [yearPlaceholder, setYearPlaceholder] = useState("");
  const [finalYear, setFinalYear] = useState("");
  const [finalYeardisplayed, setFinalYeardisplayed] = useState("");

  const [yearsOptions, setYearsOptions] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const animatedComponents = makeAnimated();
  const [isClicked, setIsClicked] = useState(false);
  const [toByYear, setToByYear] = useState([]);
  const printRef = useRef(); // Ref for the printable section

  const handleYearChange = (selectedOption) => {
    setSelectedYear(selectedOption);
    setFinalYear(selectedOption.label);
    console.log(`Option selected:`, selectedOption);
  };

  useEffect(() => {
    SocieteService.getFinacialYearsAndMonthsFromSocieteCreationDate()
      .then((response) => {
        if (response.data["success"] !== undefined) {
          const today = new Date();
          const yyyy = today.getFullYear();
          setFinalYear(yyyy);
          setYearPlaceholder(yyyy);

          const yearsOptions = response.data["success"].years.map(
            (year, index) => ({
              value: index,
              label: year,
            })
          );
          setYearsOptions([...yearsOptions]);
        }
      })
      .catch((error) => {
        console.log("error: " + error);
      });
  }, []);

  const getAllClientsInfoByAnnee = (e) => {
    setIsClicked(true);
    startLoading();
    KPIAchatService.getFicheAllClientsInfoByAnnee(getCurrentUserId(), finalYear)
      .then((response) => {
        setToByYear(response.data.success);
        setFinalYeardisplayed(finalYear)
      })
      .catch((error) => {
        console.log("error: " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();

    if (Array.isArray(toByYear) && toByYear.length === 0 && yyyy === finalYear) {
      getAllClientsInfoByAnnee();
    }
  }, [finalYear, toByYear, getAllClientsInfoByAnnee]);



  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "black" }}
                >
                  All Client
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Choisir un an</h3>
                </div>
                <div className="card-body">
                  <div className="form-group col-4 col-sm-4">
                    <div>
                      <label>Choisir l'année </label>
                      <Select
                        value={selectedYear}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        options={yearsOptions}
                        onChange={handleYearChange}
                        defaultValue={selectedYear}
                        placeholder={yearPlaceholder}
                      />
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <button
                    type="submit"
                    onClick={getAllClientsInfoByAnnee}
                    className="btn btn-dark float-right"
                  >
                    Valider
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ClientTable toByYear={toByYear} finalYear={finalYeardisplayed} />
    </div>
  );
};

export default withLoader(AllClient);
